export const MONTH_MAPPER: { [key: string]: string } = {
  '00': 'january',
  '01': 'february',
  '02': 'march',
  '03': 'april',
  '04': 'may',
  '05': 'june',
  '06': 'july',
  '07': 'august',
  '08': 'september',
  '09': 'october',
  '10': 'november',
  '11': 'december',
}
